import { createContext, useContext } from 'react'

export type ChatAccountNames = Record<string, string>

/** Survives navigation so account tooltips stay available in prior chat turns. */
const accountNamesByTenant = new Map<string, ChatAccountNames>()

export function rememberChatAccountNames(tenantId: string, names: ChatAccountNames): void {
  if (!tenantId || Object.keys(names).length === 0) return
  const prev = accountNamesByTenant.get(tenantId) ?? {}
  accountNamesByTenant.set(tenantId, { ...prev, ...names })
}

export function getRememberedChatAccountNames(tenantId: string | undefined): ChatAccountNames {
  if (!tenantId) return {}
  return accountNamesByTenant.get(tenantId) ?? {}
}

const ChatAccountNamesContext = createContext<ChatAccountNames>({})

export const ChatAccountNamesProvider = ChatAccountNamesContext.Provider

export function useChatAccountNames(): ChatAccountNames {
  return useContext(ChatAccountNamesContext)
}
